import React, {useCallback, useEffect, useState, memo} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {currentResource} from '../../../util/utils';
import {isEqual} from 'lodash';

MotifTableRemoveCellRenderer.propTypes = {
	onRemove: PropTypes.func,
	showLoader: PropTypes.bool,
	loadingIndicatorType: PropTypes.string
};

function MotifTableRemoveCellRenderer({data, node, visible}) {
	const [show, setShow] = useState(false);

	const handleOnClick = useCallback(() => {
		if (data.remove.onRemove) {
			data.remove.onRemove(data);
		}
	}, [data?.remove]);

	const handleOnRowMouseEnter = useCallback(() => setShow(true));
	const handleOnRowMouseLeave = useCallback(() => setShow(false));

	useEffect(() => {
		node.addEventListener('mouseEnter', handleOnRowMouseEnter);
		node.addEventListener('mouseLeave', handleOnRowMouseLeave);

		return () => {
			node.removeEventListener('mouseEnter', handleOnRowMouseEnter);
			node.removeEventListener('mouseLeave', handleOnRowMouseLeave);
		};
	}, []);

	const removeVisible = !visible || visible(data);
	return (
		<>
			{show && (
				<StyledMotifTableRemoveCellRenderer
					removeVisible={removeVisible}
					onClick={handleOnClick}
					className="StyledMotifTableRemoveCellRenderer"
				>
					{currentResource.labels.remove}
				</StyledMotifTableRemoveCellRenderer>
			)}
		</>
	);
}

export default memo(MotifTableRemoveCellRenderer, (prevProps, nextProps) => isEqual(prevProps, nextProps));

const StyledMotifTableRemoveCellRenderer = styled.a`
	display: ${(props) => (!props.removeVisible ? 'none' : 'block')};
	margin: auto;
	font-size: var(--px-14);
	font-weight: 400;
	cursor: pointer;
	color: var(--blue-600) !important;
	width: 100%;
	text-align: right;
`;
